module.exports = __webpack_public_path__ + "img/add-account.8b605d90.svg";